<template>
    <el-dialog
        :model-value="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        class="delete-modal"
        width="500px"
        :show-close="false"
        center
    >
        <template #header="{ close }">
            <div class="custom-header">
                <span @click="close" class="close-text">
                    {{ $trans("profile_dossier.cancel") }}
                    <el-icon class="custom-close-icon"><Close /></el-icon>
                </span>
            </div>
        </template>

        <div class="modal-body-content">
            {{ $trans("profile_dossier.delete_message") }}
        </div>

        <template #footer>
            <div class="dialog-footer">
                <el-button
                    class="grey-button"
                    @click="$emit('update:modelValue', false)"
                >
                    {{ $trans("profile_dossier.cancel") }}
                </el-button>
                <el-button
                    class="red-button"
                    type="danger"
                    @click="handleConfirm"
                >
                    {{ $trans("profile_dossier.delete") }}
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import { Close } from "@element-plus/icons-vue";

export default {
    name: "DeleteDossierModal",
    components: {
        Close,
    },
    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
    },
    emits: ["update:modelValue", "confirm"],
    methods: {
        handleClose() {
            this.$emit("update:modelValue", false);
        },
        handleConfirm() {
            this.$emit("confirm");
            this.handleClose();
        },
    },
};
</script>

<style scoped>
.delete-modal :deep(.el-dialog__header) {
    padding: 15px 20px 10px;
    margin-right: 0;
    border-bottom: none;
}

.delete-modal :deep(.el-dialog__body) {
    padding: 10px 30px 20px;
    font-size: 22px;
    color: #3c3c3c;
    text-align: center;
}

.delete-modal :deep(.el-dialog__footer) {
    border-top: none;
    padding: 10px 20px 20px;
}

:deep(.el-dialog__headerbtn) {
    position: absolute;
    top: 6px;
    right: 0;
    padding: 0;
    width: 88px;
    height: 63px;
    background: 0 0;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: var(--el-message-close-size, 16px);
}

.custom-header {
    display: flex;
    justify-content: flex-end;
    position: relative;
    font-size: 18px;
    font-style: italic;
    color: #000;
}

.close-text {
    cursor: pointer;
    display: flex;
    align-items: center;
}

.close-icon-placeholder {
    display: inline-block;
    width: 30px;
    height: 30px;
    margin-left: -5px;
    position: relative;
    right: -25px;
}

.dialog-footer {
    display: flex;
    gap: 15px;
    width: 100%;
}

.dialog-footer .el-button {
    flex-grow: 1;
    width: 100%;
    font-size: 16px;
    padding: 18px 10px;
    border-radius: 4px;
}

.grey-button {
    background-color: #f2f2f2;
    border-color: #f2f2f2;
    color: #606266;
}
.grey-button:hover,
.grey-button:focus {
    background-color: #e6e6e6;
    border-color: #e6e6e6;
    color: #303133;
}

.red-button {
    background-color: rgb(255, 107, 101);
    border-color: rgb(255, 107, 101);
    color: white;
}

.red-button:hover,
.red-button:focus {
    background-color: rgb(155, 69, 79);
    border-color: rgb(155, 69, 79);
}

.delete-modal :deep(.el-dialog__headerbtn .el-dialog__close) {
    width: 35px !important;
    height: 59px !important;
}

.modal-body-content {
    font-size: 22px;
    color: #3c3c3c !important;
}

.custom-close-icon {
    font-size: 35px;
    margin-left: 10px;
    vertical-align: middle;
}

.close-text {
    cursor: pointer;
    display: flex;
    align-items: center;
}
</style>
